export const menuList = [
    {
        id: 1,
        path: "/",
        label: "Inicio"
    },
    {
        id: 2,
        path: "/about",
        label: "Sobre mí"
    },
    {
        id: 3,
        path: "/service",
        label: "¿Qué ofrezco?"
    },
    {
        id: 4,
        path: "/works",
        label: "Proyectos"
    },
    {
        id: 5,
        path: "/contact",
        label: "Contacto"
    },

]